import React from 'react';
import { connect } from 'react-redux';

import Registry from '../../../registry/index';
import { PmWindowContextMenu } from '../PmWindowContextMenu/index';
import UserContextMenuItem from '../UserContextMenuItem/index';
import ShortUserInfo from '../UserInfoTooltip/ShortUserInfo'

import { hidePmWindow } from '../../../actions/pm';
import { openVideoWindow }  from '../../../actions/streaming';
import { SIDEBAR_RIGHT_HIDE } from '../../../constants/sidebars';
import { BobTVUser, findUser } from '../BobTVUser/index';

class PmMenu extends PmWindowContextMenu {
    constructor(props) {
        super(props);
    }
    componentDidMount() {} // override unnecessary parent method
    componentWillUnmount() {}

    view = () => {
        const { user, openVideoWindow, dispatch } = this.props;
        openVideoWindow(user.ufrag);
        dispatch({type: SIDEBAR_RIGHT_HIDE});
    };

    closePm = () => {
        const { user, hidePmWindow, dispatch } = this.props;
        hidePmWindow(user);
        dispatch({type: SIDEBAR_RIGHT_HIDE});
    };

    render () {
        let lang = Registry.get('locale');

        let { user, currentUser, currentRoom, watchingMe } = this.props;

        let allItemsBase = super.getAllItems(lang, user, currentRoom);
        let allItems = {
            view: allItemsBase['view'],
            profile: allItemsBase['profile'],
            follow: allItemsBase['follow'],
            unfollow: allItemsBase['unfollow'],
            virtual_gift: allItemsBase['virtual_gift'],
            give_xxl: allItemsBase['give_xxl'],
            block: allItemsBase['block'],
            unblock: allItemsBase['unblock'],
            exclude: allItemsBase['exclude'],
            ban: allItemsBase['ban'],
            revoke: {onClick: (event) => this.action(event, 'revoke'), label: lang.revoke_pm},
            deleteHistory: allItemsBase['deleteHistory'],
            closePm: {onClick: (event) => this.action(event, 'closePm'), label: lang.close_pm},
        };

        let availableItems = [];

        for (let action in allItems) {
            let item = allItems[action];
            let disabled = !super.itemEnabled(action, user, currentUser);

            if (super.itemVisible(action, user, currentUser)) {
                availableItems.push(<UserContextMenuItem key={action} {...item} disabled={disabled}/>);
            }
        }

        let watching = false;
        Object.keys(watchingMe).forEach(key => {
            if (key === user.ufrag) {
                watching = true;
            }
        });

        return (
            <div className="pm-sidebar">
                <div className="top-block-right-cont pm">
                    <div className="base-info">
                        <span className={`user-type-icon ${user.gender ? 'male' : 'female'}`} />
                        <div className="nick">{user.nick}</div>
                        <div className={`user-status-icons ${watching && ' watching ' } ${user.streaming && ' streaming ' }`}>
                            <span className="eye" />
                            <span className="video" />
                        </div>
                    </div>
                    <div className="short-info">
                        <ShortUserInfo user={user} lang={lang} />
                    </div>
                </div>
                <ul id="user-list" className="show-user-info">
                    {availableItems}
                </ul>
            </div>

            
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    let user = {};
    Object.keys(state.pm.conversations).forEach(key => {
        if (state.pm.conversations[key].view.maximized) {
            user = new BobTVUser(state.pm.conversations[key].user);
            user = findUser(state, user);
        }
    });

    return {
        currentRoom: state.currentRoom,
        currentUser: state.currentUser,
        watchingMe: state.watchingMe,
        user,
    }
};

const mapDispatchToProps = { openVideoWindow, hidePmWindow };

export default connect(mapStateToProps, mapDispatchToProps)(PmMenu);




// WEBPACK FOOTER //
// ./src/components/bobtv-neo/PmMenuMobile/index.js